import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const DrawingTitleColumn = ({ data }: Props) => {
	const {
		state: { dataDrawingSelected },
	} = useTemplatesContext();

	if (data.id === -1) {
		return (
			<Grid
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid item style={{ alignItems: "center", justifyContent: "center" }}>
					{dataDrawingSelected?.Title}
				</Grid>
			</Grid>
		);
	} else if (data.id !== -1) {
		return <>{data?.Title}</>;
	} else return <></>;
};
